import { TRANSLATABLE_PUBLISH_STATUSES_FILTER } from 'config/translatableConstants/TRANSLATABLE_PUBLISH_STATUSES';
import general_messages from 'messages/general_messages';

const publishStatus = {
  sectionName: general_messages.publish_status,
  filters: TRANSLATABLE_PUBLISH_STATUSES_FILTER,
};

export default publishStatus;
